import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/homePageView.vue";
import Global from "@/Global";
import { Toast } from "vant";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      title: "首页",
    },
  },
  {
    path: "/threejsShow2",
    name: "threejsShow2",
    component: () => import("../views/threejsShow2.vue"),
    meta: {
      title: "threejs比对展示",
    },
  },
  {
    path: "/modelDetail",
    name: "modelDetail",
    component: () => import("../views/modelDetail.vue"),
    meta: {
      title: "比对",
    },
  },
  {
    path: "/loginMobileOld",
    name: "loginMobileOld",
    component: () => import("../views/loginMobileOld.vue"),
    meta: {
      title: "手机号登录",
    },
  },
  {
    path: "/loginMobileNew1",
    name: "loginMobileNew1",
    component: () => import("../views/loginMobileNew1.vue"),
    meta: {
      title: "手机号登录",//新
    },
  },
  {
    path: "/loginMobile",
    name: "loginMobile",
    component: () => import("../views/loginMobile2.vue"),
    meta: {
      title: "手机号登录",//新2
    },
  },
  {
    path: "/videoAnalysis",
    name: "videoAnalysis",
    component: () => import("../views/videoAnalysis.vue"),
    meta: {
      title: "视频解析",
    },
  },
  {
    path: "/videoAnalysis2",
    name: "videoAnalysis2",
    component: () => import("../views/videoAnalysis2.vue"),
    meta: {
      title: "视频解析",
      keepAlive: true,
      isUseCache: false,
    },
  },
  {
    path: "/userEdit",
    name: "userEdit",
    component: () => import("../views/userEdit.vue"),
    meta: {
      title: "我的信息",
    },
  },
  {
    path: "/personSel",
    name: "personSel",
    component: () => import("../views/personSel.vue"),
    meta: {
      title: "人员选择",
    },
  },
  {
    path: "/analyticActionDetail",
    name: "analyticActionDetail",
    component: () => import("../views/analyticActionDetail.vue"),
    meta: {
      title: "动作详情",
    },
  },
  {
    path: "/rankingList",
    name: "rankingList",
    component: () => import("../views/rankingList.vue"),
    meta: {
      title: "排行榜",
    },
  },
  {
    path: "/rankingList2",
    name: "rankingList2",
    component: () => import("../views/rankingList2.vue"),
    meta: {
      title: "排行榜",//新
    },
  },
  {
    path: "/uploadVideos",
    name: "uploadVideos",
    component: () => import("../views/uploadVideos.vue"),
    meta: {
      title: "排行榜",
    },
  },
  {
    path: "/changePerson",
    name: "changePerson",
    component: () => import("../views/changePerson.vue"),
    meta: {
      title: "切换解析人员",
    },
  },
  {
    path: "/uploadBoot",
    name: "uploadBoot",
    component: () => import("../views/uploadBoot.vue"),
    meta: {
      title: "上传指导",
    },
  },
  {
    path: "/uploadBoot2",
    name: "uploadBoot2",
    component: () => import("../views/uploadBoot2.vue"),
    meta: {
      title: "上传指导",//新
    },
  },
  {
    path: "/uploadVideos2",
    name: "uploadVideos2",
    component: () => import("../views/uploadVideos2.vue"),
    meta: {
      title: "上传视频",//新
    },
  },
  {
    path: "/runningGroupList",
    name: "runningGroupList",
    component: () => import("../views/runningGroupList.vue"),
    meta: {
      title: "跑团",
    },
  },
  {
    path: "/realName",
    name: "realName",
    component: () => import("../views/realName.vue"),
    meta: {
      title: "实名认证",
    },
  },
  {
    path: "/addRunningList",
    name: "addRunningList",
    component: () => import("../views/addRunningList.vue"),
    meta: {
      title: "创建跑团",
    },
  },
  {
    path: "/addRunningList2",
    name: "addRunningList2",
    component: () => import("../views/addRunningList2.vue"),
    meta: {
      title: "创建跑团",//新
    },
  },
  {
    path: "/groupDetail",
    name: "groupDetail",
    component: () => import("../views/groupDetail.vue"),
    meta: {
      title: "跑团详情",
    },
  },
  {
    path: "/groupMember",
    name: "groupMember",
    component: () => import("../views/groupMember.vue"),
    meta: {
      title: "跑团成员列表",
    },
  },
  {
    path: "/groupApproval",
    name: "groupApproval",
    component: () => import("../views/groupApproval.vue"),
    meta: {
      title: "入团审核",
    },
  },
  {
    path: "/runNotice",
    name: "runNotice",
    component: () => import("../views/runNotice.vue"),
    meta: {
      title: "跑团通知",
    },
  },
  {
    path: "/runNoticeDel",
    name: "runNoticeDel",
    component: () => import("../views/runNoticeDel.vue"),
    meta: {
      title: "跑团详情",
    },
  },
  {
    path: "/runGroupDetail",
    name: "runGroupDetail",
    component: () => import("../views/runGroupDetail.vue"),
    meta: {
      title: "跑团详情",
    },
  },
  {
    path: "/runGroupDetail2",
    name: "runGroupDetail2",
    component: () => import("../views/runGroupDetail2.vue"),
    meta: {
      title: "跑团详情",//新
    },
  },
  {
    path: "/addNotice",
    name: "addNotice",
    component: () => import("../views/addNotice.vue"),
    meta: {
      title: "新增跑团公告",
    },
  },
  {
    path: "/discoverRun",
    name: "discoverRun",
    component: () => import("../views/discoverRun.vue"),
    meta: {
      title: "发现跑团",
    },
  },
  {
    path: "/discoverRun2",
    name: "discoverRun2",
    component: () => import("../views/discoverRun2.vue"),
    meta: {
      title: "发现跑团",//新
    },
  },
  {
    path: "/vipBuy",
    name: "vipBuy",
    component: () => import("../views/vipBuy.vue"),
    meta: {
      title: "VIP购买",
    },
  },
  {
    path: "/vipBuyResult",
    name: "vipBuyResult",
    component: () => import("../views/vipBuyResult.vue"),
    meta: {
      title: "VIP购买结果",
    },
  },
  // {
  //   path: "/homePageView",
  //   name: "homePageView",
  //   component: () => import("../views/homePageView.vue"),
  //   meta: {
  //     title: "首页",
  //   },
  // },
  {
    path: "/uploadGuide",
    name: "uploadGuide",
    component: () => import("../views/uploadGuide.vue"),
    meta: {
      title: "上传引导",
    },
  },
  {
    path: "/historicalFile",
    name: "historicalFile",
    component: () => import("../views/historicalFile.vue"),
    meta: {
      title: "历史档案",
    },
  },
  {
    path: "/runReport",
    name: "runReport",
    component: () => import("../views/runReport.vue"),
    meta: {
      title: "跑步档案",
    },
  },
  // {
  //   path: "/runDel",
  //   name: "runDel",
  //   component: () => import("../views/runDel.vue"),
  //   meta: {
  //     title: "跑团详情",
  //   },
  // },
  {
    path: "/maintainView",
    name: "maintainView",
    component: () => import("../views/maintainView.vue"),
    meta: {
      title: "系统维护中",
    },
  },
  {
    path: "/revenueOverview",
    name: "revenueOverview",
    component: () => import("../views/revenueOverview.vue"),
    meta: {
      title: "收益概览",
    },
  },
  {
    path: "/statisticalData",
    name: "statisticalData",
    component: () => import("../views/statisticalData.vue"),
    meta: {
      title: "统计数据",
    },
  },
  {
    path: "/loginByToken",
    name: "loginByToken",
    component: () => import("../views/loginByToken.vue"),
    meta: {
      title: "登录",
    },
  },
];

const router = new VueRouter({
  mode: "",
  base: process.env.BASE_URL,
  routes,
});

const whiteList = ["loginMobile", "maintainView", "loginByToken"];
router.beforeEach((to, from, next) => {
  // let flag = true;
  if (whiteList.indexOf(to.name) == -1) {
    if (localStorage.getItem(Global.GlobalLocalToken) == null) {
      Toast("缺少用户信息，请重新登录");
      next("/loginMobile");
    }
    else {
      next()
      
      // let localUrl = sessionStorage.getItem(Global.GlobalLocalLeaveUrl)
      // alert(to.path + '-' + localUrl)
      // if (to.path === localUrl) {
      //   alert('返回的')
      //   sessionStorage.removeItem(Global.GlobalLocalLeaveUrl)
      //   // next({
      //   //   path: localUrl,
      //   //   replace: true
      //   // })
      //   window.history.go(-1); // 回退一级
      //   next({
      //     path: localUrl,
      //     query: {
      //       editSuccess: new Date().valueOf()
      //     },
      //     replace: true
      //   })
      // }
      // else {
      //   next()
      // }
    }
  }
  else {
    next();
  }
});

export default router;
